import {Component, OnInit} from '@angular/core';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
import {ActivatedRoute} from '@angular/router';
import {ModalService} from 'angular-modal-simple';
import {Title} from '@angular/platform-browser';
import {AboutUsService} from "../core/about-us.service";
import {Person} from "../shared/types/types";
import {PersonModalComponent} from "./person-modal/person-modal.component";

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  personList: Person[] = [];

  constructor(private gaService: GoogleAnalyticsService, private modalService: ModalService,
              private activatedRoute: ActivatedRoute, private titleService: Title, private aboutUsService: AboutUsService) {
  }

  async ngOnInit() {
    this.titleService.setTitle('EREF fizioterápia - Munkatársaink');
    // this.gaService.pageView('/munkatarsaink', 'Munkatársaink');
    this.personList = await this.aboutUsService.getAboutUsFromContentful();

    this.activatedRoute.url.subscribe(url => url[1] ? this.showModal(this.personList.find(person => person.url === url[1].path)) : {});
  }

  showModal(person: Person | undefined) {
    console.log(person);
    if(person) {
      this.modalService.display(PersonModalComponent, {
        data: {person}
      });
    }
  }
}
